module.exports = __webpack_public_path__ + "assets/filter-discounts-1479c4.svg";